import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import util from "@/libs/util.js";
export default {
  data: function data() {
    return {
      searchForm: {},
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据

      // 表单
      form: {},
      dialogVisible: false // 弹窗状态
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  watch: {
    $route: function $route() {
      this.getData();
    }
  },
  methods: {
    deleteMenu: function deleteMenu(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this2.$confirm("\u786E\u8BA4\u5220\u9664\u5417?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return _this2.$api.deleteMenu({
                        id: row.id
                      });
                    case 1:
                      _this2.$message.success("操作成功");
                      _this2.getData();
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getData: function getData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this3.tableLoading = true;
              res = {};
              if (!_this3.$route.query.parentId) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return _this3.$api.getMenuChildList({
                id: _this3.$route.query.parentId
              });
            case 1:
              res = _context4.v;
              _context4.n = 4;
              break;
            case 2:
              _context4.n = 3;
              return _this3.$api.getMenuList(_this3.searchForm);
            case 3:
              res = _context4.v;
            case 4:
              _this3.tableData = res.data;
              _this3.tableLoading = false;
            case 5:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this4.form.parentId = _this4.$route.query.parentId || "0";
              _this4.form.adminId = util.cookies.get("uuid");
              if (!_this4.form.id) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return _this4.$api.updateMenu({
                id: _this4.form.id,
                adminId: _this4.form.adminId,
                parentId: _this4.form.parentId,
                menuName: _this4.form.menuName,
                menuCode: _this4.form.menuCode
              });
            case 1:
              _context5.n = 3;
              break;
            case 2:
              _context5.n = 3;
              return _this4.$api.addMenu(_this4.form);
            case 3:
              _this4.dialogVisible = false;
              _this4.form = {};
              _this4.getData();
            case 4:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};